import PropTypes from 'prop-types'
import { createContext, useContext, useMemo } from 'react'

import { readPartnerTableColumns } from '../helpers/table-column-settings'
import { readPartnerTalentStatuses } from '../helpers/talent-statuses'

const PartnerContext = createContext()

PartnerContext.displayName = 'PartnerContext'

export function PartnerContextProvider(props) {
  const value = useMemo(() => {
    const report_v1_settings = JSON.parse(
      props.partner.app_settings?.report_v1_settings || '{}'
    )

    const report_v2_settings = JSON.parse(
      props.partner.app_settings?.report_v2_settings || '{}'
    )

    const dashboard_settings = JSON.parse(
      props.partner.app_settings?.dashboard_settings || '{}'
    )

    const isV1ScoreVisible = report_v1_settings.score_visible ?? true
    const isV2ScoreVisible = report_v2_settings.score_visible ?? true

    // Dashboard component visibility settings
    // Components are visible by default, only hidden if explicitly set to false
    const isDashboardComponentVisible = {
      assessmentMonitor:
        dashboard_settings.assessment_monitor_visible !== false,
      culturalFit: dashboard_settings.cultural_fit_visible !== false,
      matching: dashboard_settings.matching_visible !== false,
      discover: !!dashboard_settings.experimental?.components?.discover === true
    }

    // Partnerweit deaktivierte Tabellenspalten (Admin-Einstellung unter
    // Dashboard-Komponenten). Nutzer erben sie und können sie nicht einblenden.
    const disabledTableColumns = readPartnerTableColumns(dashboard_settings)

    // Eigene Talent-Status des Partners (Admin-Einstellung), inkl. archivierter,
    // damit bereits markierte Talente ihr Label behalten.
    const talentStatuses = readPartnerTalentStatuses(dashboard_settings)

    return {
      partner: {
        ...props.partner,
        isV1ScoreVisible,
        isV2ScoreVisible,
        isDashboardComponentVisible,
        disabledTableColumns,
        talentStatuses
      },
      refetchPartner: props.refetchPartner
    }
  }, [props.partner, props.refetchPartner])

  return <PartnerContext.Provider value={value} {...props} />
}

PartnerContextProvider.propTypes = {
  partner: PropTypes.object.isRequired,
  refetchPartner: PropTypes.func.isRequired
}

export function usePartnerContext() {
  const context = useContext(PartnerContext)

  if (!context) {
    throw new Error('usePartnerContext must be used within a AppProvider')
  }

  return context
}
